import {TextField} from '@mui/material';
import {WBButton} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

export const Container = styled.div<{selected: boolean}>`
  ${p =>
    p.selected &&
    css`
      box-shadow: 0 0 0 6px light-dark(rgb(208, 225, 252), var(--blue-700));
    `}
`;

export const EditContainer = styled.div`
  background-color: ${globals.THEME.bgSurfaceSunken};
  padding: 24px;
  margin-bottom: 24px;
`;

export const EditMessage = styled.div<{marginTop?: boolean}>`
  font-style: italic;
  margin-bottom: 24px;
  ${p =>
    p.marginTop &&
    css`
      margin-top: 24px;
    `}
`;

export const EditInputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

export const EditTextField = styled(TextField).attrs({variant: 'standard'})`
  flex-grow: 1;
`;

export const SubmitButton = styled(WBButton).attrs({variant: `confirm`})<{
  marginLeft?: boolean;
  marginTop?: boolean;
}>`
  &&& {
    ${p =>
      p.marginLeft &&
      css`
        margin-left: 16px;
      `}

    ${p =>
      p.marginTop &&
      css`
        margin-top: 16px;
      `}
  }
`;
